import React, { Fragment } from 'react'
import DefaultAvatar from "../../images/default_avatar.jpg"
import CountrycodeSegment from './Countrycode';


const BasicInfo = ({
    counteryCode,
    phone_number,
    fb_link,
    avatar_url,
    avatarPreview,
    setCounteryCode,
    setPhoneNumber,
    setFb_link,
    setAvatar_url,
    setAvatarPreview,
    handleFileChange
}) => {



    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (setImage, setPreview) => (e) => {
        e.preventDefault();

        const file = e.dataTransfer.files[0];

        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };




    return (
        <Fragment>
            <div className="bg-white p-6 rounded-xl border border-zinc-200 shadow-sm">
                
                {/* Header */}
                <div className="flex items-center gap-4 mb-6">
                    <div className="w-10 h-10 bg-zinc-900 rounded-lg flex items-center justify-center text-white flex-shrink-0">
                        <i className="fa-solid fa-user text-sm"></i>
                    </div>
                    <div>
                        <h3 className="text-base font-semibold text-zinc-900">Basic Information</h3>
                        <p className="text-xs text-zinc-500">Basic details about you.</p>
                    </div>
                </div>

                <div className="grid grid-cols-1 gap-4 mb-6">
                    
                    {/* Whatsapp Number */}
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Whatsapp Number <span className="text-red-500">*</span></label>
                        <div className="flex border border-zinc-200 rounded-lg overflow-hidden focus-within:border-zinc-900 focus-within:ring-1 focus-within:ring-zinc-900 transition-all">
                            <select 
                                value={counteryCode}
                                onChange={(e) => setCounteryCode(e.target.value)}
                                className="px-3 py-2.5 bg-zinc-50 text-sm text-zinc-700 outline-none border-r border-zinc-200 font-medium"
                            >
                                <CountrycodeSegment />
                            </select>
                            <input
                                type="number"
                                value={phone_number}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                className="flex-1 px-4 py-2.5 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white"
                                placeholder="300 0000000"
                            />
                            <div className="flex items-center justify-center px-4 bg-white">
                                <i className="fa-brands fa-whatsapp text-emerald-500 text-lg"></i>
                            </div>
                        </div>
                    </div>

                    {/* Facebook Link */}
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Facebook Link <span className="text-zinc-400 font-normal">(Optional)</span></label>
                        <div className="flex border border-zinc-200 rounded-lg overflow-hidden focus-within:border-zinc-900 focus-within:ring-1 focus-within:ring-zinc-900 transition-all">
                            <input
                                type="text"
                                value={fb_link}
                                onChange={(e) => setFb_link(e.target.value)}
                                className="flex-1 px-4 py-2.5 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white"
                                placeholder="facebook.com/username"
                            />
                            <div className="flex items-center justify-center px-4 bg-white">
                                <i className="fa-brands fa-facebook text-blue-600 text-lg"></i>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Profile Picture */}
                <div className="flex flex-col md:flex-row items-center md:items-end gap-6">
                    <div className="w-20 h-20 rounded-full bg-zinc-100 overflow-hidden flex-shrink-0 border border-zinc-200">
                        <img src={avatarPreview || DefaultAvatar} alt="profile pic" className="w-full h-full object-cover" />
                    </div>
                    
                    <div className="flex-1 flex flex-col w-full">
                        <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Profile Picture <span className="text-red-500">*</span></label>
                        <div
                            className="border border-dashed border-zinc-300 rounded-lg p-4 flex gap-4 items-center cursor-pointer hover:bg-zinc-50 transition-colors"
                            onDrop={handleDrop(setAvatar_url, setAvatarPreview)}
                            onDragOver={handleDragOver}
                            onClick={() => document.getElementById("profilePictureInput").click()}
                        >
                            <input
                                id="profilePictureInput"
                                type="file"
                                accept="image/png, image/jpeg"
                                onChange={handleFileChange(setAvatar_url, setAvatarPreview)}
                                className="hidden"
                            />
                            <div className="w-10 h-10 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-600 flex-shrink-0">
                                <i className="fa-solid fa-arrow-up-from-bracket text-sm"></i>
                            </div>
                            <p className="text-xs text-zinc-500">
                                Drop your image here, or <span className="font-semibold text-zinc-900">click to upload</span>.
                                <br />
                                PNG or JPG only.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default BasicInfo
